import React, { useState } from 'react';
import { AccordionItem } from '@ui-elements';
import styles from './index.module.scss';

interface AccordionItemDto {
  itemTitle?: string;
  itemDescription?: string;
  key?: string;
}

interface GenericAccordionProps {
  id?: number;
  title?: string;
  items?: AccordionItemDto[];
}

const GenericAccordion = (props: GenericAccordionProps) => {
  const { title, items } = props;
  const [expandedKey, setExpandedKey] = useState<string | null>(null);

  if (!items || items.length === 0) return null;

  const domId = props.id ? `cid-generic-accordion-${props.id}` : undefined;

  return (
    <div id={domId} className={styles.genericAccordion}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.items}>
        {items.map((item, i) => {
          const key = item.key || `item-${i}`;
          return (
            <AccordionItem
              key={key}
              title={item.itemTitle || ''}
              content={item.itemDescription || ''}
              expanded={expandedKey === key}
              onExpandChange={(open) => setExpandedKey(open ? key : null)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GenericAccordion;
